import {DefaultPinProperties, GroupPinProperties} from "../constants";

export const getMarkersData = (mapNode, id) => {
	const elements = Array.from(document.querySelectorAll(`.map-marker[data-for="${id}"][data-latitude][data-latitude], .grouped-map-marker[data-for="${id}"][data-latitude][data-latitude], .transport-map-marker[data-for="${id}"][data-latitude][data-latitude], .route-map-marker[data-for="${id}"][data-coordinates]`));

	let divSubway;
	let subwayLine;
	let subwayColor;
	
	if ( mapNode.closest(`.infrastructure`) )
	{
		divSubway = document.createElement(`div`);
		divSubway.classList.add(`subway`);
		mapNode.appendChild(divSubway);
		subwayLine = elements.find((el) => el.getAttribute(`data-subway-line`) ? el : false);
		if ( subwayLine )
		{
			subwayLine = subwayLine.getAttribute(`data-subway-line`);
			divSubway.classList.add(`subway--line-${subwayLine}`);
			subwayColor = getComputedStyle(divSubway).getPropertyValue(`background-color`);
		}
	}
	
	const dataMarkers = elements.map((data, i) => ({
		id: i,
		latitude: data.getAttribute(`data-latitude`),
		longitude: data.getAttribute(`data-longitude`),
		icon: data.getAttribute(`data-icon`) || DefaultPinProperties.PATH,
		iconWidth: data.hasAttribute(`data-group`) || data.hasAttribute(`data-subway-line`) ? GroupPinProperties.WIDTH : DefaultPinProperties.WIDTH,
		iconHeight: data.hasAttribute(`data-group`) || data.hasAttribute(`data-subway-line`) ? GroupPinProperties.HEIGHT : DefaultPinProperties.HEIGHT,
		get iconAnchorX ()
		{
			return this.iconWidth / -2;
		},
		get iconAnchorY ()
		{
			return this.iconHeight * -1;
		},
		markup: data.getAttribute(`data-markup`),
		group: data.getAttribute(`data-group`),

		complexHref: data.getAttribute(`data-complex-href`),
		complex: data.getAttribute(`data-complex`),
		coordinates: JSON.parse(data.getAttribute(`data-coordinates`)),
		groupColor: data.getAttribute(`data-group-color`),
		subwayLine: data.getAttribute(`data-subway-line`),
		subwayColor,
	}));
	
	if ( divSubway )
	{
		divSubway.remove();
	}
	
	return dataMarkers;
};
